import { objectEntries } from 'core/utils';
import get from 'lodash/get';
import type { TreeGrid } from './types';

/**
 * @deprecated Use createDataMapper instead
 */
export const createTreeGridAdapter = <
  TColumns extends string,
  TItem extends Record<string, unknown>,
>(
  map: TreeGrid.ColumnsMap,
) => {
  const entries: [TColumns, TreeGrid.MapConfig][] = objectEntries<TreeGrid.ColumnsMap, TColumns>(
    map,
  ).map(([colName, path]) => {
    if (Array.isArray(path)) {
      return [
        colName,
        {
          path,
          from: (v: unknown) => v,
          to: (v: unknown) => v,
        },
      ];
    }

    return [colName, path];
  });

  return <TreeGrid.DataAdapter<TColumns, TItem>>{
    convertTo: (item, cb) => {
      entries.forEach(([colName, mapConfig]) => {
        const { path, to } = mapConfig;
        cb(colName, to(get(item, path)));
      });
    },
    convertFrom: (item, cb) => {
      entries.forEach(([colName, mapConfig]) => {
        if (Object.hasOwn(item, colName)) {
          const { path, from } = mapConfig;
          cb(path, from(get(item, colName)));
        }
      });
    },
  };
};

export const createTreeGridMapper = createTreeGridAdapter;
